'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');
const LoadUrlMatcherTypes=require('../../../../dist-es6/client/services/paramSyncService').LoadUrlMatcherTypes;let

LoginConfig=function(){_createClass(LoginConfig,null,[{key:'$inject',get:function()
{return['$stateProvider','$urlMatcherFactoryProvider']}}]);

function LoginConfig($stateProvider,$urlMatcherFactoryProvider){_classCallCheck(this,LoginConfig);
LoadUrlMatcherTypes($urlMatcherFactoryProvider);
let feature=AngularHelpers.generateFeatureConfig('login',{
url:'/login?state&passwordResetRequest&return_to',
reloadOnSearch:!1,
params:{
sessionHasExpired:!1,
state:'login',
return_to:null},

views:{
"header@":{}}});


$stateProvider.state(feature.fullName,feature.config);
}return LoginConfig}();


module.exports=LoginConfig;
//# sourceMappingURL=loginConfig.js.map
